import React from "react";
import { BookOpenIcon, GiftIcon, SmartphoneIcon, CalendarCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/images";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
const benefits = [{
  icon: BookOpenIcon,
  label: "6 volúmenes"
}, {
  icon: GiftIcon,
  label: "4 bonos incluidos"
}, {
  icon: SmartphoneIcon,
  label: "Acceso digital"
}, {
  icon: CalendarCheckIcon,
  label: "Plan de 30 días"
}];
export function HeroSection() {
  const {
    mainPrice
  } = useLocalizedPrices();
  return <section id="inicio" className="relative overflow-hidden bg-cocoa-950 text-cream-100" data-id="element-139" data-mp="30n55a8zsmoak">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 pb-8 pt-4 sm:pb-16 sm:pt-14 lg:grid-cols-[1.05fr_1fr] lg:gap-14 lg:pb-24 lg:pt-20" data-id="element-140" data-mp="2mrtcw89419wt">
        <div className="min-w-0" data-id="element-141" data-mp="3fibf7720f796">
          <p className="mb-4 hidden text-xs font-semibold uppercase tracking-[0.24em] text-caramel-300 sm:block" data-id="element-142" data-mp="3fha1svxiu8oa">
            Una colección digital de Aura Content
          </p>
          <h1 className="font-display text-[1.75rem] font-semibold leading-[1.12] tracking-tight text-cream-50 sm:text-6xl sm:leading-[1.05] lg:text-[4.25rem]" data-id="element-143" data-mp="2fgbnd7vjylei">
            <span className="block" data-id="element-144" data-mp="2p51xj70qxfol">Tu plan de 30 días para</span>
            <span className="block" data-id="element-145" data-mp="2p7eo28kkkyd9">empezar a vender </span>
            <em className="block font-medium text-caramel-400" data-id="element-146" data-mp="2kdk4r68vmlep">desde casa</em>
          </h1>

          <div className="-mx-5 mt-3 sm:mx-0 lg:hidden" data-id="element-147" data-mp="2z2q02j4lfrhb">
            <HeroImage data-id="element-148" data-mp="2z5c6gffr00xy" />
          </div>

          <ul className="mt-3 grid grid-cols-2 gap-2 sm:mt-8 sm:flex sm:flex-wrap" aria-label="Qué incluye" data-id="element-149" data-mp="2u3d4n9znpc34">
            {benefits.map(b => {
            const Icon = b.icon;
            return <li key={b.label} className="flex min-w-0 items-center justify-center gap-1.5 rounded-full border border-cream-50/15 bg-cream-50/5 px-2 py-1.5 text-xs font-medium text-cream-100 sm:px-3 sm:text-sm" data-id="element-150" data-mp="3365ud8t6xfqu">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-caramel-400" aria-hidden="true" data-id="element-151" data-mp="38tl31msngrxd" />
                  {b.label}
                </li>;
          })}
          </ul>

          <div className="mt-3.5 sm:mt-8" data-id="element-152" data-mp="3irins0baw6l8">
            <CtaButton label="Quiero mi plan de 30 días" data-id="element-153" data-mp="3iqpofkeo8jd4" />
          </div>
          <p className="mt-1.5 text-center text-sm text-cream-300 sm:mt-2 sm:text-left" data-id="element-154" data-mp="3mtm2qyx6htb9">
            Pago único de <strong className="font-semibold text-cream-50" data-id="element-155" data-mp="3rsyy682488pg">{mainPrice}</strong>
          </p>
          <p className="mt-3 text-center text-[10px] font-semibold uppercase tracking-[0.24em] text-caramel-300/90 sm:hidden" data-id="element-156" data-mp="lcmbs58szxi">
            Una colección digital de Aura Content
          </p>
        </div>

        <div className="hidden lg:block" data-id="element-157" data-mp="abyy1b9u96ax">
          <HeroImage showCaption data-id="element-158" data-mp="aaw6r28lt1uh" />
        </div>
      </div>
    </section>;
}
function HeroImage({
  showCaption = false
}: {
  showCaption?: boolean;
}) {
  return <figure className="relative" data-id="element-159" data-mp="jdf97l8h9cg7">
      <img src={images.booksMockup} alt="Los 6 volúmenes de «De tu cocina a tus primeros pedidos» junto a brownies y cookies" width={1312} height={1199} className="block aspect-[4/3] w-full object-cover object-center sm:mx-auto sm:aspect-auto sm:max-w-md sm:rounded-2xl sm:object-contain sm:shadow-[0_30px_60px_-20px_rgba(0,0,0,0.7)] lg:max-w-none" data-id="element-160" data-mp="jcnbo4vbl4na" />
      {showCaption && <figcaption className="absolute -bottom-4 left-6 rounded-full bg-cream-50 px-4 py-2 text-xs font-semibold text-cocoa-900 shadow-lg" data-id="element-161" data-mp="2mkwe79q2ca7x">
          6 volúmenes + 4 bonos
        </figcaption>}
    </figure>;
}